export const events = {
  confirmation: {
    open: '@CeralPortalTomadaPreco/CONFIRMATION/open',
    close: '@CeralPortalTomadaPreco/CONFIRMATION/close',
    confirm: '@CeralPortalTomadaPreco/CONFIRMATION/confirm',
    cancel: '@CeralPortalTomadaPreco/CONFIRMATION/cancel',
  },
}
